export default __webpack_public_path__ + "static/media/redeem.2e86ae09.svg";